/* eslint-disable max-classes-per-file */
import { ICorrectiveActionRequest } from '../models/corrective-action.model';

export class GetCorrectiveActionById {
  static readonly type = '[Corrective Action] Get Corrective Action By Id';
  constructor(public id: string) {}
}

export class LoadCorrectiveActionsForIO {
  static readonly type = '[Corrective Action] Load Corrective Actions For IO';
}

export class CreateCorrectiveAction {
  static readonly type = '[Corrective Action] Create Corrective Action';
  constructor(public correctiveAction: ICorrectiveActionRequest) {}
}

export class UpdateCorrectiveAction {
  static readonly type = '[Corrective Action] Update Corrective Action';
  constructor(public correctiveAction: ICorrectiveActionRequest) {}
}

export class DeleteCorrectiveAction {
  static readonly type = '[Corrective Action] Delete Corrective Action';
  constructor(public id: string) {}
}

export class PrintCorrectiveAction {
  static readonly type = '[Corrective Action] Print Corrective Action';
  constructor(public id: string) {}
}
